import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useUpdateTrailer() {
    const { uid } = useFirebaseAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const updateTrailer = useCallback(
        async (trailerId, trailerData) => {
            if (!uid) {
                setError(new Error('User not authenticated.'));
                return;
            }
            setLoading(true);
            setError(null);
            setSuccess(false);

            try {
                // Ensure licensePlate is a flat string, not a nested object
                const payload = {
                    ...trailerData,
                    licensePlate: trailerData.licensePlate?.licensePlate || trailerData.licensePlate,
                    trailerCapacity:
                      trailerData.trailerCapacity ?? trailerData.capacity ?? null,
                    cmrInvoiceUploaded: Boolean(
                      trailerData.cmrInvoiceUploaded ?? trailerData.hasCmrInvoice,
                    ),
                };
                await API.put(`/users/${uid}/trailers/${trailerId}`, payload);
                setSuccess(true);   
            } catch (err) {
                setError(err);
            }
            finally {
                setLoading(false);
            }
        },
        [uid]
    );
    return { updateTrailer, loading, error, success };
}
